export default "__VITE_ASSET__6f17c052__"